<template>
  <div class="!pt-0">
    <div class="flex flex-col space-y-6 max-h-screen pt-16 pb-2.5">
      <!-- Header Section -->
      <div class="flex items-center justify-between space-x-4 mt-2.5">
        <div class="flex items-center space-x-4 element-island">
          <div class="flex items-center space-x-3">
            <div class="w-10 h-10 bg-gradient-to-r from-orange-500 to-orange-600 rounded-lg flex items-center justify-center">
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 text-white">
<path fill-rule="evenodd" clip-rule="evenodd" d="M4.87171 1.58811C4.18324 1.9184 4.34293 2.75714 4.79289 3.20711L9.08579 7.5L7.5 9.08579L3.20711 4.79289C2.75711 4.3429 1.90944 4.19971 1.58419 4.87995C0.985604 6.1319 0.769329 7.54124 0.975579 8.9287C1.23113 10.6478 2.11708 12.2104 3.46105 13.3124C4.80502 14.4144 6.51089 14.977 8.24676 14.8908C8.89048 14.8588 9.52124 14.7385 10.1228 14.537L17.8787 22.2929C19.0503 23.4645 20.9497 23.4645 22.1213 22.2929L22.2929 22.1213C23.4645 20.9497 23.4645 19.0503 22.2929 17.8787L14.537 10.1228C14.7395 9.51835 14.8601 8.8844 14.8913 8.2375C14.9753 6.50151 14.4104 4.79638 13.3066 3.45387C12.2028 2.11135 10.6391 1.22746 8.91964 0.974169C7.53192 0.769745 6.12286 0.987876 4.87171 1.58811ZM12.0945 10.5087C12.5356 9.7995 12.793 8.98448 12.834 8.13802C12.8932 6.91285 12.4946 5.70946 11.7156 4.76198C10.9366 3.8145 9.83297 3.19069 8.61946 3.01193C8.21216 2.95193 7.80225 2.94351 7.39883 2.98462L10.5 6.08579C11.2811 6.86684 11.281 8.13317 10.5 8.91421L8.91421 10.5C8.13317 11.281 6.86684 11.281 6.08579 10.5L2.98467 7.39888C2.94336 7.8044 2.95209 8.21647 3.01295 8.62584C3.1933 9.8391 3.81856 10.9419 4.76707 11.7196C5.71557 12.4974 6.91949 12.8944 8.14458 12.8336C8.98967 12.7916 9.80314 12.5338 10.511 12.093L11.9946 13.5766L11.9924 13.5782L19.2929 20.8787C19.6834 21.2692 20.3166 21.2692 20.7071 20.8787L20.8787 20.7071C21.2692 20.3166 21.2692 19.6834 20.8787 19.2929L12.0945 10.5087Z" fill="currentColor"/>
</svg>
            </div>

            <div>
              <h1 class="font-bold text-2xl text-gray-900">
                {{ $t('SelfPerform.PlantDashboard.title') }}
              </h1>

              <p class="text-sm text-gray-600">
                {{ $t('SelfPerform.PlantDashboard.subTitle') }}
              </p>
            </div>
          </div>

          <a
            :href="exportUrl"
            target="_blank"
            class="btn btn--secondary-blue inline-flex items-center space-x-2"
          >
            <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" class="w-4 h-4">
<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
</svg>

            <span>{{ $t('SelfPerform.PlantDashboard.button.export') }}</span>
          </a>

          <button
            type="button"
            class="btn btn--secondary-blue inline-flex items-center space-x-2"
            @click="showReport = true"
          >
            <svg fill="none" stroke="currentColor" viewBox="0 0 24 24"  class="w-4 h-4">
    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
</svg>

            <span>{{ $t('SelfPerform.PlantDashboard.button.utilisationReport') }}</span>
          </button>
        </div>

        <div class="flex space-x-3 element-island">
          <button
            v-if="projectsStore.project?.unarchived"
            type="button"
            class="btn btn--primary-blue inline-flex items-center space-x-2"
            data-test="add-plant"
            @click="show = true"
          >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-4 h-4">
  <path fill-rule="evenodd" d="M12 3.75a.75.75 0 01.75.75v6.75h6.75a.75.75 0 010 1.5h-6.75v6.75a.75.75 0 01-1.5 0v-6.75H4.5a.75.75 0 010-1.5h6.75V4.5a.75.75 0 01.75-.75z" clip-rule="evenodd" />
</svg>

            <span>{{ $t('SelfPerform.PlantDashboard.button.plant') }}</span>
          </button>

          <button
            type="button"
            class="btn inline-flex items-center space-x-2"
            :class="[plantsStore.active ? 'btn--primary-blue' : 'btn--secondary-blue']"
            data-test="show-filter"
            @click="showFilter = true"
          >
            <svg
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
 class="w-4 h-4">
    <path
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke-width="2"
    d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z"
    />
</svg>

            <span>{{ $t('SelfPerform.PlantDashboard.button.filter') }}</span>
          </button>
        </div>
      </div>

      <!-- Main Content -->
      <div
        v-if="plants.length === 0 && fetchPlantsAction.state.value === States.COMPLETE"
        class="element-island text-center py-12"
        data-test="no-plant-message"
      >
        <div class="w-24 h-24 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-6">
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="w-12 h-12 text-gray-400">
<path fill-rule="evenodd" clip-rule="evenodd" d="M4.87171 1.58811C4.18324 1.9184 4.34293 2.75714 4.79289 3.20711L9.08579 7.5L7.5 9.08579L3.20711 4.79289C2.75711 4.3429 1.90944 4.19971 1.58419 4.87995C0.985604 6.1319 0.769329 7.54124 0.975579 8.9287C1.23113 10.6478 2.11708 12.2104 3.46105 13.3124C4.80502 14.4144 6.51089 14.977 8.24676 14.8908C8.89048 14.8588 9.52124 14.7385 10.1228 14.537L17.8787 22.2929C19.0503 23.4645 20.9497 23.4645 22.1213 22.2929L22.2929 22.1213C23.4645 20.9497 23.4645 19.0503 22.2929 17.8787L14.537 10.1228C14.7395 9.51835 14.8601 8.8844 14.8913 8.2375C14.9753 6.50151 14.4104 4.79638 13.3066 3.45387C12.2028 2.11135 10.6391 1.22746 8.91964 0.974169C7.53192 0.769745 6.12286 0.987876 4.87171 1.58811ZM12.0945 10.5087C12.5356 9.7995 12.793 8.98448 12.834 8.13802C12.8932 6.91285 12.4946 5.70946 11.7156 4.76198C10.9366 3.8145 9.83297 3.19069 8.61946 3.01193C8.21216 2.95193 7.80225 2.94351 7.39883 2.98462L10.5 6.08579C11.2811 6.86684 11.281 8.13317 10.5 8.91421L8.91421 10.5C8.13317 11.281 6.86684 11.281 6.08579 10.5L2.98467 7.39888C2.94336 7.8044 2.95209 8.21647 3.01295 8.62584C3.1933 9.8391 3.81856 10.9419 4.76707 11.7196C5.71557 12.4974 6.91949 12.8944 8.14458 12.8336C8.98967 12.7916 9.80314 12.5338 10.511 12.093L11.9946 13.5766L11.9924 13.5782L19.2929 20.8787C19.6834 21.2692 20.3166 21.2692 20.7071 20.8787L20.8787 20.7071C21.2692 20.3166 21.2692 19.6834 20.8787 19.2929L12.0945 10.5087Z" fill="currentColor"/>
</svg>
        </div>

        <h3 class="text-lg font-semibold text-gray-900 mb-2">
          {{ $t('SelfPerform.PlantDashboard.noPlantFound') }}
        </h3>

        <p class="text-gray-600 mb-6">
          {{ $t('SelfPerform.PlantDashboard.tryAdjustingFilters') }}
        </p>

        <button
          v-if="projectsStore.project?.unarchived"
          type="button"
          class="btn btn--primary-blue inline-flex items-center space-x-2"
          @click="show = true"
        >
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-4 h-4">
  <path fill-rule="evenodd" d="M12 3.75a.75.75 0 01.75.75v6.75h6.75a.75.75 0 010 1.5h-6.75v6.75a.75.75 0 01-1.5 0v-6.75H4.5a.75.75 0 010-1.5h6.75V4.5a.75.75 0 01.75-.75z" clip-rule="evenodd" />
</svg>

          <span>{{ $t('SelfPerform.PlantDashboard.button.addFirstPlant') }}</span>
        </button>
      </div>

      <div
        v-else-if="fetchPlantsAction.state.value === States.COMPLETE"
        class="element-island overflow-y-auto"
      >
        <PlantList
          :plants="plants"
          :project-id="$props.projectId"
        />
      </div>

      <div
        v-else
        class="element-island flex items-center justify-center py-12"
      >
        <AppSpinner class="h-8 w-8" />
      </div>

      <!-- Modals -->
      <PlantSaveModal
        v-if="show"
        :project-id="$props.projectId"
        @close="show = false"
      />

      <PlantFilterModal
        v-if="showFilter"
        @close="showFilter = false"
        @filter="setFilter"
        @clear="clearFilter"
      />

      <PlantUtilisationReport
        v-if="showReport"
        @close="showReport = false"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import PlantFilterModal from '@/components/PlantDashboard/PlantFilterModal.vue';
import PlantList from '@/components/PlantDashboard/PlantList.vue';
import PlantSaveModal from '@/components/PlantDashboard/PlantSaveModal.vue';
import PlantUtilisationReport from '@/components/PlantDashboard/PlantUtilisationReport.vue';
import { useProjectTypeRedirect } from '@/composables/useProjectTypeRedirect';
import { States, useStoreApiAction } from '@/composables/useStoreApiAction';
import { usePlantsStore } from '@/store/plants';
import { useProjectsStore } from '@/store/projects';
import { useVariationOrdersStore } from '@/store/variationOrders';
import { useWbsCodesStore } from '@/store/wbsCodes';
import { route } from '@/ziggy-shim';
import { computed, ref, watch } from 'vue';

const props = defineProps<{
  projectId: string;
}>();

const plantsStore = usePlantsStore();
const wbsCodesStore = useWbsCodesStore();
const fetchPlantsAction = useStoreApiAction(plantsStore.fetchPlants);
const indexWbsCodesAction = useStoreApiAction(wbsCodesStore.index);
const variationOrdersStore = useVariationOrdersStore();
const fetchApprovedVariations = useStoreApiAction(variationOrdersStore.fetchApprovedVariationOrders);

watch(() => props.projectId, () => {
  plantsStore.filter.resetData();

  fetchPlantsAction.request(props.projectId, plantsStore.filter.form).catch((error) => {
    console.log(error);
  });

  indexWbsCodesAction.request(props.projectId).catch((error) => {
    console.log(error);
  });

  fetchApprovedVariations.request(props.projectId);
}, { immediate: true });

const show = ref(false);
const showFilter = ref(false);

const plants = computed(() =>
  plantsStore.models
    .with('supplier')
    .with('project')
    .with('records', (query) =>
      query
        .with('user').orderBy('day')
        .with('wbsCode')
        .with('comments', (query) => query.with('creator'))
        .with('plant', (query) => query.with('project')))
    .with('on_hired', (query) => {
      return query.orderBy('id');
    })
    .where('project_id', parseInt(props.projectId))
    .get()
);

const clearFilter = () => {
  showFilter.value = false;
  plantsStore.filter.resetData();
  plantsStore.models.flush();
  plantsStore.active = false;

  fetchPlantsAction.request(props.projectId).catch((error) => {
    console.log(error);
  });
};

const setFilter = () => {
  showFilter.value = false;
  plantsStore.models.flush();

  fetchPlantsAction.request(props.projectId, plantsStore.filter.form).then(() => {
    plantsStore.active = true;
  }).catch((error) => {
    console.log(error);
  });
};

const projectsStore = useProjectsStore();
const showReport = ref(false);

const exportUrl = computed(() => {
  if(projectsStore.project) {
    return route('api.v1.projects.export', projectsStore.project.id);
  }

  return undefined;
});

useProjectTypeRedirect();
</script>

<style scoped></style>
